import React from 'react';
import * as S from './styled';

const Section = ({
  title,
  titleClassName,
  subTitle,
  children,
  extraHeader,
  mobile,
  inlineChildren,
  fullWidth,
  className,
  ...other
}) => (
  <S.SectionWrapper {...other} className={`Section ${className}`}>
    {title && (
      <S.SectionTitle className={titleClassName}>{title}</S.SectionTitle>
    )}
    {subTitle && <S.SectionSubtitle>{subTitle}</S.SectionSubtitle>}
    {inlineChildren ? (
      <S.InlineChildrenWrapper fullWidth={fullWidth}>
        {children}
      </S.InlineChildrenWrapper>
    ) : (
      children
    )}
  </S.SectionWrapper>
);

export default Section;
